export function wait( delay: number ) {
	return new Promise( resolve => setTimeout( resolve, delay ) );
}

export function filterUniqueStrings( val: string, index: number, array: string[] ) {
	return array.indexOf( val ) === index;
}
